import {Divider} from '@mui/material';
import Drawer from '@mui/material/Drawer';
import React from 'react';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {SupportTicketRelatedTasksDrawerHeader} from './SupportTicketRelatedTasksDrawerHeader';
import {SupportTicketRelatedTasksDrawerTable} from './SupportTicketRelatedTasksDrawerTable';

export type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void

  ticket: SupportTicketModel
  translate: (key: string) => string
}

export const SupportTicketRelatedTasksDrawer = ({isDrawerOpen, onDrawerClosed, ticket, translate}: Props) => {
  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: '50%',
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <SupportTicketRelatedTasksDrawerHeader
      translate={translate}
      ticket={ticket}
    />
    <Divider sx={{ my: 2 }} />
    <SupportTicketRelatedTasksDrawerTable
      relatedTasks={ticket.relatedTasks ?? []}
      translate={translate}
    />
  </Drawer>
}